import { render, staticRenderFns } from "./TheDashboard.vue?vue&type=template&id=f9fdf246"
import script from "./TheDashboard.vue?vue&type=script&lang=js"
export * from "./TheDashboard.vue?vue&type=script&lang=js"
import style0 from "./TheDashboard.vue?vue&type=style&index=0&id=f9fdf246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VPagination,VResponsive,VRow,VSwitch})
